import script from "./ProjectInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectInfo.vue?vue&type=script&setup=true&lang=js"

import "./ProjectInfo.vue?vue&type=style&index=0&id=051f5f0a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-051f5f0a"]])

export default __exports__